import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

//Components
import CustomMap from "../../../../components/CustomMap";

//Shared
import FichaRequerimento from "../../../Shared/FichaRequerimento";

//Context
import { useAuth } from "../../../../context/auth";

//Api
import mapaDeSupressoes_api from "../../../../api/mapaDeSupressoes_api";

//Helpers
import { showMessage } from "../../../../helpers/message";

export default function MapaDeSupressoes({ permissoes }) {
    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Estado que guarda os pontos que foram suprimidos
    const [pontosDeSupressao, setPontosDeSupressao] = useState(null);

    //Estado que guarda o id do requerimento para carregamento da ficha
    const [requerimentoId, setRequerimentoId] = useState();
    const { setLoading } = useAuth();

    const onClickMarker = (marker) => {
        setRequerimentoId(marker.requerimento_Id);
    }

    //Função que carrega os pontos do mapa
    const loadPontos = () => {
        setLoading(true);
        mapaDeSupressoes_api.mapaDeSupressoes().then(response => {
            response.data = response.data.map(value => {
                value.coordenadas = [parseFloat(value.latitude), parseFloat(value.longitude)];
                return value;
            })
            setPontosDeSupressao(response.data);
        }).catch(ex => showMessage("Erro", ex.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadPontos();
    }, []);

    if (requerimentoId)
        return (
            <FichaRequerimento requerimentoId={requerimentoId} btnVoltar={() => setRequerimentoId(null)} editavel={editavel} />
        )

    return (
        <>
            <Row style={{ height: "500px" }}>
                <Col md="12" lg="12" className="rounded overflow-hidden p-0" >
                    <CustomMap
                        onClickMarker={onClickMarker}
                        markers={pontosDeSupressao}
                    />
                </Col>
            </Row>
        </>
    )
}